import { Box, BoxProps, Text } from '@chakra-ui/core';
import React, { useState } from 'react';

interface RevealSeedProps extends BoxProps {
  mnemonic: string;
  revealable?: boolean;
  forceReveal?: boolean;
  onAttemptReveal?: () => void;
}
const RevealSeed = ({
  mnemonic,
  revealable = true,
  forceReveal = false,
  onAttemptReveal,
  ...boxProps
}: RevealSeedProps) => {
  const [revealed, setRevealed] = useState(false);

  const onReveal = () => {
    if (revealable) return setRevealed(true);
    if (onAttemptReveal) onAttemptReveal();
  };

  return (
    <Box position="relative" {...boxProps}>
      {!(revealed || forceReveal) && (
        <Box
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
          left="0"
          width="100%"
          height="100%"
          backgroundColor="#848484"
          color="white"
        >
          <Text textTransform="uppercase" fontSize="xs" onClick={onReveal}>
            Click here to reveal secret words
          </Text>
        </Box>
      )}
      <Text
        border="1px solid black"
        padding="10px"
        style={{ wordSpacing: '4px' }}
      >
        <span data-hj-suppress>{mnemonic}</span>
      </Text>
    </Box>
  );
};

export default RevealSeed;
